var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "#818181",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33302 13.0018C6.33302 12.6336 6.6315 12.3351 6.99969 12.3351H12.9997C13.3679 12.3351 13.6664 12.6336 13.6664 13.0018C13.6664 13.37 13.3679 13.6684 12.9997 13.6684H6.99969C6.6315 13.6684 6.33302 13.37 6.33302 13.0018Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 2.25423C10.8014 2.25423 10.6113 2.33299 10.4711 2.47318L2.26833 10.6759L1.91593 12.0855L3.32552 11.7331L11.5283 3.53037C11.5977 3.46096 11.6528 3.37855 11.6903 3.28785C11.7279 3.19716 11.7472 3.09995 11.7472 3.00178C11.7472 2.90361 11.7279 2.8064 11.6903 2.7157C11.6528 2.62501 11.5977 2.5426 11.5283 2.47318C11.4589 2.40377 11.3765 2.3487 11.2858 2.31114C11.1951 2.27357 11.0979 2.25423 10.9997 2.25423ZM9.52828 1.53037C9.91852 1.14013 10.4478 0.920898 10.9997 0.920898C11.273 0.920898 11.5435 0.974722 11.796 1.0793C12.0485 1.18387 12.2779 1.33715 12.4711 1.53037C12.6643 1.7236 12.8176 1.953 12.9222 2.20546C13.0267 2.45792 13.0806 2.72851 13.0806 3.00178C13.0806 3.27504 13.0267 3.54563 12.9222 3.7981C12.8176 4.05056 12.6643 4.27996 12.4711 4.47318L4.13776 12.8065C4.05232 12.892 3.94527 12.9526 3.82805 12.9819L1.16138 13.6485C0.934196 13.7053 0.693871 13.6388 0.528284 13.4732C0.362697 13.3076 0.296131 13.0673 0.352927 12.8401L1.01959 10.1734C1.0489 10.0562 1.10951 9.94915 1.19495 9.86371L9.52828 1.53037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b56a2207a707bda4aa3a8fe08b2defa2.svg";
export { ForwardRef as ReactComponent };